export default {
    admin: {
        title: "Dashboard",
        subtitle: "System overview and account management",
        newAccount: "New Account",
        loading: "Loading dashboard...",
        stats: {
            totalAccounts: "Total Accounts",
            activeAccounts: "Active Accounts",
            newThisMonth: "New This Month",
            suspendedAccounts: "Suspended Accounts",
        },
        recentAccounts: {
            title: "Recent Accounts",
            description: "Last 5 accounts created in the system",
            viewAll: "View all",
            headers: {
                userType: "User Type",
                legalName: "Legal Name",
                entityType: "Entity Type",
                country: "Country",
                status: "Status",
                createdAt: "Creation Date",
            },
            status: {
                active: "Active",
                suspended: "Suspended",
                inactive: "Inactive",
            },
        },
    },
    sender: {
        title: "Dashboard",
        subtitle: "Overview of containers and collaborations",
        loading: "Loading dashboard...",
        stats: {
            totalContainers: "Total Containers",
            inTransit: "In Transit",
            delivered: "Delivered",
            delayed: "Delayed",
            pendingDocuments: "Pending Documents",
            highRisk: "High Risk",
        },
        collaborations: {
            title: "Collaborations",
            total: "Total",
            active: "Active",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Total",
            active: "Active",
        },
        recentContainers: {
            title: "Recent Containers",
            description: "Last 5 containers created",
            viewAll: "View all",
            headers: {
                containerId: "Container ID",
                route: "Route",
                progress: "Progress",
                eta: "ETA",
                docStatus: "Doc Status",
                riskLevel: "Risk Level",
                value: "Value",
            },
        },
    },
    shipper: {
        title: "Dashboard",
        subtitle: "Overview of containers and collaborations",
        loading: "Loading dashboard...",
        stats: {
            totalContainers: "Total Containers",
            inTransit: "In Transit",
            delivered: "Delivered",
            delayed: "Delayed",
            pendingDocuments: "Pending Documents",
            highRisk: "High Risk",
        },
        collaborations: {
            title: "Collaborations",
            total: "Total",
            active: "Active",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Total",
            active: "Active",
        },
        recentContainers: {
            title: "Recent Containers",
            description: "Last 5 containers created",
            viewAll: "View all",
            headers: {
                containerId: "Container ID",
                route: "Route",
                progress: "Progress",
                eta: "ETA",
                docStatus: "Doc Status",
                riskLevel: "Risk Level",
                value: "Value",
            },
        },
    },
    receiver: {
        title: "Dashboard",
        subtitle: "Overview of received containers and collaborations",
        loading: "Loading dashboard...",
        newOrderRequest: "New Order Request",
        manageShippers: "Manage Shippers",
        viewContainers: "View Containers",
        newOrderModal: {
            title: "New Order Request",
            shipper: "Shipper",
            shipperPlaceholder: "Select a shipper",
            targetWeek: "Target Week",
            packingList: "Requested Packing List",
            packingListPlaceholder: "Describe in detail the requested packing list...",
            notes: "Notes",
            notesPlaceholder: "Additional notes about the order...",
            submit: "Create Order"
        },
        stats: {
            totalContainers: "Total Containers",
            inTransit: "In Transit",
            delivered: "Delivered",
            delayed: "Delayed",
            pendingDocuments: "Pending Documents",
            highRisk: "High Risk",
        },
        collaborations: {
            title: "Collaborations",
            total: "Total",
            active: "Active",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Total",
            active: "Active",
        },
        recentContainers: {
            title: "Recent Containers",
            description: "Last 5 containers received",
            viewAll: "View all",
            headers: {
                containerId: "Container ID",
                shipper: "Shipper",
                route: "Route",
                progress: "Progress",
                docStatus: "Doc Status",
                riskLevel: "Risk Level",
            },
        },
        monthlyTrend: {
            title: "Monthly Trend",
        },
        trendVsLastMonth: "vs last month",
        receivedContainers: "Received Containers",
        activeShippers: "Active Shippers",
        charts: {
            commodityDistribution: "Commodity Distribution",
            originCountries: "Origin Countries",
            arrivalPorts: "Arrival Ports",
        },
    },
};
